import React from "react";

const CardSkeleton = () => {
  return (
    <div className="animate-pulse flex flex-col overflow-hidden rounded-lg shadow-lg ring">
      <div className="flex-shrink-0 bg-teal-100 h-48 w-full" />
      <div className="flex flex-1 flex-col justify-between bg-white p-6">
        <div className="flex-1 space-y-4">
          <div className="h-4 bg-teal-100 rounded w-1/4" />
          <div className="h-6 bg-teal-100 rounded w-3/4" />
          <div className="h-4 bg-teal-100 rounded w-full" />
        </div>
        <div className="mt-6 flex items-center space-x-2">
          <div className="h-6 w-6 bg-teal-100 rounded-full" />
          <div className="h-4 bg-teal-100 rounded w-1/4" />
        </div>
      </div>
    </div>
  );
};

export default CardSkeleton;
